export default __webpack_public_path__ + "static/media/email.3b3f754f.svg";